import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Button,
  Checkbox,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
  ListItemText,
} from "@mui/material";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";

const EditSubscription = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isAddSubscription = location.pathname === "/subscriptions/add";

  const [subscriptionType, setSubscriptionType] = useState<string>("");
  const [tierLevel, setTierLevel] = useState<string>("");

  const [financialDashboard, setFinancialDashboard] = useState<string[]>([]);
  const [aiGrowthFeatures, setAiGrowthFeatures] = useState<string[]>([]);

  const [features, setFeatures] = useState<string[]>([]);
  const [featureInput, setFeatureInput] = useState<string>("");

  const handleTypeChange = (event: SelectChangeEvent) => {
    setSubscriptionType(event.target.value);
  };

  const handleMultiChange =
    (setter: React.Dispatch<React.SetStateAction<string[]>>) =>
      (event: SelectChangeEvent<string[]>) => {
        const {
          target: { value },
        } = event;

        setter(typeof value === "string" ? value.split(",") : value);
      };

  const addFeature = () => {
    if (featureInput.trim()) {
      setFeatures([...features, featureInput.trim()]);
      setFeatureInput("");
    }
  };

  return (
    <>
      {/* ---------- Header ---------- */}
      <div className="main_title">
        <h1>{isAddSubscription ? "Add" : "Edit"} Subscription</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate("/subscriptions")}>
            Manage Subscriptions
          </button>{" "}
          - {isAddSubscription ? "Add" : "Edit"} Subscription
        </p>
      </div>
      <div className="table_flex mt_20">
        <div className="lt">
          <div className="cards">
            <div className="form">
              <div className="gap_p">

                {/* Subscription Type */}
                <div className="control_group w_33">
                  <label htmlFor="sub-type">Subscription Type *</label>
                  <Select
                    fullWidth
                    value={subscriptionType}
                    onChange={handleTypeChange}
                    displayEmpty
                    inputProps={{ id: "sub-type" }}
                  >
                    <MenuItem disabled value="">
                      Select Type
                    </MenuItem>
                    <MenuItem value="Free">Free</MenuItem>
                    <MenuItem value="Paid">Paid</MenuItem>
                  </Select>
                </div>

                {/* Plan Name */}
                <div className="control_group w_33">
                  <label htmlFor="sub-plan-name">Plan Name *</label>
                  <TextField placeholder="Professional" fullWidth hiddenLabel inputProps={{ id: "sub-plan-name" }} />
                </div>

                {/* Monthly Price */}
                <div className="control_group w_33">
                  <label htmlFor="sub-monthly-price">Monthly Price ($)</label>
                  <TextField type="number" placeholder="0" fullWidth hiddenLabel inputProps={{ id: "sub-monthly-price" }} />
                </div>

                {/* Description */}
                <div className="control_group w_100">
                  <label htmlFor="sub-description">Description</label>
                  <TextField
                    multiline
                    minRows={3}
                    placeholder="Perfect for growing businesses..."
                    fullWidth
                    hiddenLabel
                    inputProps={{ id: "sub-description" }}
                  />
                </div>

                {/* Annual Price */}
                <div className="control_group w_33">
                  <label htmlFor="sub-annual-price">Annual Price ($)</label>
                  <TextField type="number" placeholder="0" fullWidth hiddenLabel inputProps={{ id: "sub-annual-price" }} />
                </div>

                {/* Trial Days */}
                <div className="control_group w_33">
                  <label htmlFor="sub-trial-days">Trial Days</label>
                  <TextField type="number" placeholder="14" fullWidth hiddenLabel inputProps={{ id: "sub-trial-days" }} />
                </div>
                <div className="control_group w_33">
                  <label htmlFor="sub-num-products">No. of Products</label>
                  <TextField type="number" placeholder="1" fullWidth hiddenLabel inputProps={{ id: "sub-num-products" }} />
                </div>
                <div className="control_group w_33">
                  <label htmlFor="sub-payout-period">Payout Period</label>
                  <TextField type="number" placeholder="10 days" fullWidth hiddenLabel inputProps={{ id: "sub-payout-period" }} />
                </div>
                <div className="control_group w_33">
                  <label htmlFor="sub-commission">Commission</label>
                  <TextField type="number" placeholder="10" fullWidth hiddenLabel inputProps={{ id: "sub-commission" }} />
                </div>
                <div className="control_group w_33">
                  <label htmlFor="sub-per-order-fees">Per Order Fees</label>
                  <TextField type="number" placeholder="100 AED" fullWidth hiddenLabel inputProps={{ id: "sub-per-order-fees" }} />
                </div>
                <div className="control_group w_33">
                  <label htmlFor="sub-media-product">Media/Product</label>
                  <TextField type="number" placeholder="5" fullWidth hiddenLabel inputProps={{ id: "sub-media-product" }} />
                </div>
                <div className="control_group w_33">
                  <label htmlFor="sub-ai-content">AI Content Assistant</label>
                  <TextField type="number" placeholder="500 uses" fullWidth hiddenLabel inputProps={{ id: "sub-ai-content" }} />
                </div>
                <div className="control_group w_33">
                  <label htmlFor="sub-chat-type">Chat Type</label>
                  <Select fullWidth displayEmpty defaultValue={"Basic"} inputProps={{ id: "sub-chat-type" }}>
                    <MenuItem disabled value="">Select</MenuItem>
                    <MenuItem value="Basic">Basic</MenuItem>
                    {/* <MenuItem value="Enhanced">Enhanced</MenuItem>
                <MenuItem value="Rich Media">Rich Media</MenuItem>
                <MenuItem value="AI-assisted">AI-assisted</MenuItem>
                <MenuItem value="CRM-integrated">CRM-integrated</MenuItem> */}
                  </Select>
                </div>

                {/* FINANCIAL DASHBOARD (MULTISELECT FIXED) */}
                <div className="control_group w_33">
                  <label htmlFor="sub-financial-dashboard">Financial Dashboard</label>
                  <Select
                    fullWidth
                    multiple
                    displayEmpty
                    value={financialDashboard}
                    onChange={handleMultiChange(setFinancialDashboard)}
                    renderValue={(selected) =>
                      selected.length === 0 ? "Select" : selected.join(", ")
                    }
                    inputProps={{ id: "sub-financial-dashboard" }}
                  >
                    {[
                      "Monthly",
                      "Weekly + CSV",
                      "Real-time",
                      "Forecasting",
                      "Reports",
                    ].map((option) => (
                      <MenuItem key={option} value={option}>
                        <ListItemText primary={option} />
                      </MenuItem>
                    ))}
                  </Select>
                </div>

                {/* SUPPORT & ADVISORY */}
                <div className="control_group w_33">
                  <label htmlFor="sub-support-advisory">Support & Advisory</label>
                  <Select fullWidth displayEmpty defaultValue={"Email"} inputProps={{ id: "sub-support-advisory" }}>
                    <MenuItem disabled value="">Select</MenuItem>
                    <MenuItem value="Email">Email</MenuItem>
                    {/* <MenuItem value="Priority Email + Group">Priority Email + Group</MenuItem>
                <MenuItem value="1x Monthly">1x / month</MenuItem>
                <MenuItem value="45min + Chat">1x (45 min) / month + chat</MenuItem>
                <MenuItem value="2x + Manager">2x / month + manager</MenuItem> */}
                  </Select>
                </div>

                {/* SERVICE MARKETPLACE DISCOUNT */}
                <div className="control_group w_33">
                  <label htmlFor="sub-service-discount">Service Marketplace Discount</label>
                  <TextField fullWidth hiddenLabel placeholder="Enter Discount" inputProps={{ id: "sub-service-discount" }} />
                  {/* <Select fullWidth displayEmpty>
                <MenuItem disabled value="">Select</MenuItem>
                <MenuItem value="0">0%</MenuItem>
                <MenuItem value="5">5%</MenuItem>
                <MenuItem value="10">10%</MenuItem>
                <MenuItem value="12">12%</MenuItem>
                <MenuItem value="15">15%</MenuItem>
              </Select> */}
                </div>

                {/* BOUTIQUE JOURNAL ACCESS */}
                <div className="control_group w_33">
                  <label htmlFor="sub-journal-access">Boutique Journal Access</label>
                  <Select fullWidth displayEmpty inputProps={{ id: "sub-journal-access" }}>
                    <MenuItem disabled value="">Select</MenuItem>
                    <MenuItem value="Read-only">Read-only</MenuItem>
                    <MenuItem value="Monthly">Monthly</MenuItem>
                    <MenuItem value="Quarterly">Quarterly</MenuItem>
                  </Select>
                </div>

                {/* EVENTS */}
                <div className="control_group w_33">
                  <label htmlFor="sub-events">Events</label>
                  <Select fullWidth displayEmpty inputProps={{ id: "sub-events" }}>
                    <MenuItem disabled value="">Select</MenuItem>
                    <MenuItem value="VIP">VIP booths</MenuItem>
                    <MenuItem value="Community">Community</MenuItem>
                    <MenuItem value="Invite">Invite</MenuItem>
                  </Select>
                </div>

                {/* Features */}
                {/* <div className="control_group w_100">
              <label>Features</label>
              <div className="feature_input">
                <TextField
                  placeholder="Add a feature..."
                  value={featureInput}
                  onChange={(e) => setFeatureInput(e.target.value)}
                  fullWidth
                  hiddenLabel
                />
                <div className="mt_10">
                  <Button onClick={addFeature} className="btn btn_primary sm">Add</Button>
                </div>
              </div>
              {features.length > 0 && (
                <ul className="feature_list">
                  {features.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              )}
            </div> */}
                {/* Limited Time Offer */}
                <div className="control_group w_33">
                  <label>Limited Time Discount</label>

                  <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
                    <TextField type="number" placeholder="Discount %" fullWidth hiddenLabel />
                    <TextField type="number" placeholder="Months" fullWidth hiddenLabel />
                  </div>
                </div>

                {/* AI GROWTH FEATURES (MULTISELECT FIXED) */}
                <div className="control_group w_100">
                  <label htmlFor="sub-ai-growth">AI Growth Features *</label>
                  <Select
                    fullWidth
                    multiple
                    displayEmpty
                    value={aiGrowthFeatures}
                    onChange={handleMultiChange(setAiGrowthFeatures)}
                    renderValue={(selected) =>
                      selected.length === 0 ? "Select" : selected.join(", ")
                    }
                    inputProps={{ id: "sub-ai-growth" }}
                  >
                    {[
                      "AI Seasonal Opportunity Predictor",
                      "AI Auto-Optimization Engine",
                      "AI Listing Quality Improvement",
                      "AI Conversion Funnel Diagnosis",
                      "AI Product Ranking Booster",
                      "AI High-Potential Product Detector",
                      "AI Geo Expansion Suggestion",
                      "AI Demand Surge & Trend Alert",
                      "AI Slow-Moving Inventory Solver",
                      "AI Returns & Cancellation Cause Predictor",
                      "AI VIP & Repeat Customer Win-back",
                      "AI Marketing Best Timing",
                      "AI Competitive Benchmarking",
                      "AI Keyword & SEO Opportunity Finder",
                      "AI Competitor Behavior & Pricing Shift Radar",
                    ].map((option) => (
                      <MenuItem key={option} value={option}>
                        <ListItemText primary={option} />
                      </MenuItem>
                    ))}
                  </Select>
                </div>


                {/* DASHBOARD FEATURES */}
                <div className="control_group w_100">
                  <label>Dashboard Features</label>
                  <div className="checkbox_group" style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
                    <label><Checkbox defaultChecked /> Level 1 — Foundational Visibility</label>
                    <label><Checkbox /> Level 2 — Performance Insights</label>
                    <label><Checkbox /> Level 3 — Operational Intelligence</label>
                    <label><Checkbox /> Level 4 — Growth & Optimization Insights</label>
                    <label><Checkbox /> Level 5 — Predictive & Foresight Intelligence</label>
                    <label><Checkbox /> Level 6 — Strategic & Autonomous Intelligence</label>
                  </div>
                </div>

                {/* AI MEDIA ENHANCEMENT */}
                <div className="control_group w_33">
                  <label htmlFor="sub-ai-media">AI Media Enhancement (Uses/Month)</label>
                  <TextField type="number" placeholder="100" fullWidth hiddenLabel inputProps={{ id: "sub-ai-media" }} />
                </div>

                {/* AI PERFORMANCE HUB */}
                <div className="control_group w_100">
                  <label>AI Performance Hub & Optimisation Insights</label>
                  <div className="checkbox_group" style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
                    <label><Checkbox defaultChecked /> Trend Analysis</label>
                    <label><Checkbox /> Competitor Benchmarking</label>
                    <label><Checkbox defaultChecked /> Pricing Optimization</label>
                    <label><Checkbox /> Demand Forecasting</label>
                    <label><Checkbox /> SKU Profitability Analysis</label>
                    <label><Checkbox /> Market Gap Identification</label>
                    <label><Checkbox /> Sentiment Analysis</label>
                    <label><Checkbox /> Return Rate Prediction</label>
                  </div>
                </div>

                {/* AI SALES OPTIMIZATION */}
                <div className="control_group w_100">
                  <label>AI Sales Optimization</label>
                  <div className="checkbox_group" style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
                    <label><Checkbox defaultChecked /> Dynamic Pricing</label>
                    <label><Checkbox /> Bundle Recommendations</label>
                    <label><Checkbox defaultChecked /> Cross-sell/Up-sell</label>
                    <label><Checkbox /> Abandoned Cart Recovery</label>
                    <label><Checkbox /> Personalized Discounts</label>
                    <label><Checkbox /> Smart Inventory Restock</label>
                    <label><Checkbox /> Conversion Rate Optimization</label>
                    <label><Checkbox /> Customer Lifecycle Prediction</label>
                  </div>
                </div>

                {/* Usage Limits */}
                <div className="control_group w_50">
                  <label htmlFor="sub-queries-limit">Queries Usage Limits</label>
                  <TextField placeholder="No. of queries" type="number" hiddenLabel inputProps={{ id: "sub-queries-limit" }} />
                </div>
              </div>

              {/* Submit */}
              <div className="form_btn">
                <Button className="btn btn_primary">
                  {isAddSubscription ? "Create Plan" : "Create Plan"}
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className="rt">
          <div className="ai_panel">
            <h4>AI Insights</h4>

            {/* Revenue vs Cost Monitor */}
            <div className="ai_alert success" style={{ background: '#f0fdf4', border: '1px solid #dcfce7' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '5px', fontWeight: 'bold', color: '#166534' }}>
                  <AccountBalanceWalletOutlinedIcon style={{ fontSize: 18 }} /> Revenue Optimization
                </div>
              </div>
              <p style={{ fontSize: '12px', marginBottom: '10px', color: '#14532d' }}>
                Subscription revenue is <b>3.5x</b> higher than service costs this month.
              </p>
              <Button fullWidth variant="contained" style={{ backgroundColor: '#fff', color: '#166534', textTransform: 'none', boxShadow: 'none', border: '1px solid #dcfce7', fontSize: '12px' }}>View Price Analysis</Button>
            </div>

            {/* Recommendation */}
            <div className="ai_alert warning" style={{ display: 'block', borderLeft: '4px solid #d97706' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '5px', fontWeight: 'bold', color: '#374151' }}>
                  <span style={{ fontSize: '16px' }}>💡</span> Discount Strategy
                </div>
              </div>
              <p style={{ fontSize: '12px', marginBottom: '15px', color: '#666' }}>
                Recommend offering <b>20% Annual Discount</b> on "Basic" plan to reduce churn.
              </p>
            </div>

            <div className="ai_alert danger">
              <span className="icon">⛔</span>
              <p>
                <b>3 SKUs</b> have zero sales in 30 days
              </p>
            </div>

            <small className="ai_update">
              Next updated ETA: <b>May 5, 2024</b>
            </small>

            <div className="ai_sku_list">
              <div className="ai_sku_row">
                <div className="ai_sku_info">
                  <h5>#PRD_002</h5>
                  <p>Likely to go out of stock by May</p>
                </div>
                <button className="ai_action_btn">Actions ▾</button>
              </div>

              <div className="ai_sku_row">
                <div className="ai_sku_info">
                  <h5>#PRD_010</h5>
                  <p>Likely to go out of stock by May</p>
                </div>
                <button className="ai_action_btn">Actions ▾</button>
              </div>
            </div>

            {/* <div className="ai_create">+ Create AI Insights</div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default EditSubscription;